import { ChangeDetectionStrategy, Component, forwardRef, Input, ViewEncapsulation } from '@angular/core';
import { FiOptionsItemBase } from '@fi-shared/fi-options/fi-options-item-base';

@Component({
    selector: 'fi-options-icon-item',
    template: ` <button
        class="fi-options-item-wrapper"
        [ngClass]="{ selected: (selected$ | async) }"
        [disabled]="disabled"
        tabindex="-1"
        mat-icon-button
        (click)="onClick()"
    >
        <mat-icon [ngClass]="'fa ' + iconClass"></mat-icon>
    </button>`,
    styleUrls: ['./fi-options-icon-item.component.scss'],
    providers: [{ provide: FiOptionsItemBase, useExisting: forwardRef(() => FiOptionsIconItemComponent) }],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-options-icon-item' },
    standalone: false,
})
export class FiOptionsIconItemComponent extends FiOptionsItemBase {
    @Input() iconClass: string;
    @Input() disabled: boolean = false;
}
